import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import CheckboxComponent from 'src/common-ui/checkbox/checkbox/checkbox.component';
export var BackgroundType;
(function (BackgroundType) {
    BackgroundType["TRANSPARENT"] = "transparent";
    BackgroundType["FILLED"] = "filled";
})(BackgroundType || (BackgroundType = {}));
export const CheckboxPanelComponent = (props) => {
    var _a;
    return (React.createElement("div", { className: `checkbox-panel ${(_a = props.backgroundType) !== null && _a !== void 0 ? _a : BackgroundType.FILLED} ${props.hint ? 'has-hint' : ''} ${props.text ? 'has-text' : ''}` },
        React.createElement(CheckboxComponent, Object.assign({}, props)),
        props.children && props.children,
        !props.children && (React.createElement(React.Fragment, null,
            props.hint && (React.createElement("div", { className: "hint", dangerouslySetInnerHTML: {
                    __html: props.skipHintTranslation
                        ? props.hint
                        : getMessage(props.hint),
                } })),
            props.text && (React.createElement("div", { className: "text", dangerouslySetInnerHTML: {
                    __html: props.skipTextTranslation
                        ? props.text
                        : getMessage(props.text),
                } }))))));
};
